import { businessCreateEmployeeSaga } from './create'

export default function* employeeSaga() {
  yield businessCreateEmployeeSaga()
}
